import React from 'react';
import { UsersIcon, CheckCircleIcon } from 'lucide-react';
export function WhoIsThisFor() {
  const audience = ['Anyone tired of expensive medicine that only works temporarily', 'Busy parents wanting safer, natural options', 'Preppers & homesteaders who want self-reliance', 'Anyone who wants control of their health again', 'People who prefer real ingredients over chemicals'];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-687">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-688">
        <div className="text-center mb-8" data-id="element-689">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-690">
            <CheckCircleIcon className="w-10 h-10 text-emerald-700" data-id="element-691" />
            <UsersIcon className="w-10 h-10 text-emerald-700" data-id="element-692" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-693">
            Who This Is For
          </h2>
        </div>
        <div className="space-y-4 mb-8" data-id="element-694">
          {audience.map((item, index) => <div key={index} className="flex items-start gap-4 bg-stone-50 p-6 rounded-lg" data-id="element-695">
              <CheckCircleIcon className="w-7 h-7 text-emerald-700 flex-shrink-0" data-id="element-696" />
              <p className="text-lg text-stone-700" data-id="element-697">{item}</p>
            </div>)}
        </div>
        <div className="text-center bg-emerald-700 text-white rounded-xl p-8" data-id="element-698">
          <p className="text-xl mb-2" data-id="element-699">You don't need to be a herbalist.</p>
          <p className="text-2xl font-bold" data-id="element-700">You just need a guide.</p>
          <p className="text-xl mt-2" data-id="element-701">And now you have one.</p>
        </div>
      </div>
    </section>;
}